// This creates a global instance cache that allows multiple instances of Laboratory Client
// to be cached within a pool and allows them to be overriden over time.
export const globalInstanceCache = new Map();